import { Route } from 'react-router';
import SubNavigationLayout from '../../common/components/SubNavigationLayout';
import ErrorBoundary from '../../common/error/ErrorBoundary';
import InternalBooking from '../internalBooking/InternalBooking';
import SelectAsset from '../internalBooking/SelectAsset';
import SubMenu from '../navigation/SubMenu';
import BookingStatistics from '../statistics/BookingStatistics';
import BookingArchive from './BookingArchive';
import Bookings from './Bookings';

/**
 * Booking feature routes
 * Base path: bookings/
 */
export const bookingRoutes = (
    <Route
        element={
            <SubNavigationLayout
                subNavigation={
                    <ErrorBoundary key="/submenu/bookings">
                        <SubMenu parentId="bookings" />
                    </ErrorBoundary>
                }
            />
        }
    >
        <Route
            index
            element={
                <ErrorBoundary key="bookings">
                    <Bookings />
                </ErrorBoundary>
            }
        />
        <Route
            path="archive"
            element={
                <ErrorBoundary key="bookings/archive">
                    <BookingArchive />
                </ErrorBoundary>
            }
        />
        <Route
            path="statistics"
            element={
                <ErrorBoundary key="bookings/statistics">
                    <BookingStatistics />
                </ErrorBoundary>
            }
        />
        <Route path="new">
            <Route
                index
                element={
                    <ErrorBoundary key="bookings/new">
                        <SelectAsset />
                    </ErrorBoundary>
                }
            />
            <Route
                path=":id"
                element={
                    <ErrorBoundary key="bookings/new/:id">
                        <InternalBooking />
                    </ErrorBoundary>
                }
            />
        </Route>
    </Route>
);
